
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Box, Calendar, Building2, Settings } from 'lucide-react';
import { api } from '../../services/api';
import { Project } from '../../api/types';

const Projects: React.FC = () => {
    const navigate = useNavigate();
    const [projects, setProjects] = useState<Project[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadProjects();
    }, []);

    const loadProjects = async () => {
        try {
            const data = await api.getProjects();
            setProjects(data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-white">Proyectos</h1>
                    <p className="text-slate-400">Gestiona tus workspaces de prueba</p>
                </div>
                <button
                    onClick={() => navigate('/projects/new')}
                    className="flex items-center gap-2 px-4 py-2 bg-primary hover:bg-blue-600 text-white rounded-lg transition-colors"
                >
                    <Plus className="w-5 h-5" />
                    <span>Nuevo Proyecto</span>
                </button>
            </div>

            {loading ? (
                <div className="text-center text-slate-500 py-10">Cargando proyectos...</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {projects.map((p) => (
                        <div
                            key={p.id}
                            onClick={() => navigate(`/projects/${p.id}`)} // V8.1: Go to Workspace
                            className="bg-surface-dark border border-slate-800 p-5 rounded-xl hover:border-primary/50 cursor-pointer transition-all group relative"
                        >
                            {/* Settings Shortcut */}
                            <button
                                onClick={(e) => { e.stopPropagation(); navigate(`/projects/${p.id}/settings`); }}
                                className="absolute top-4 right-4 p-2 text-slate-500 hover:text-white rounded-lg hover:bg-slate-700 z-10"
                                title="Configurar Proyecto"
                            >
                                <Settings className="w-4 h-4" />
                            </button>

                            <div className="flex justify-between items-start mb-4">
                                <div className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center group-hover:bg-primary/20 group-hover:text-primary transition-colors">
                                    <Box className="w-5 h-5 text-slate-400 group-hover:text-primary" />
                                </div>
                                {p.template_id && (
                                    <span className="px-2 py-1 bg-purple-500/20 text-purple-400 text-xs rounded border border-purple-500/30 mr-8">
                                        {p.template_id}
                                    </span>
                                )}
                            </div>
                            <h3 className="text-lg font-semibold text-white mb-1">{p.name}</h3>
                            <div className="flex items-center gap-2 text-xs text-slate-500 mb-4">
                                <Building2 className="w-3 h-3" />
                                <span>{p.org_id}</span>
                            </div>

                            <div className="pt-4 border-t border-slate-800 flex items-center text-xs text-slate-500">
                                <Calendar className="w-3 h-3 mr-1" />
                                Created {p.created_at ? new Date(p.created_at).toLocaleDateString() : 'N/A'}
                            </div>
                        </div>
                    ))}

                    {projects.length === 0 && (
                        <div className="col-span-full text-center py-12 bg-slate-800/30 rounded-xl border border-dashed border-slate-700">
                            <p className="text-slate-400">No hay proyectos creados aún.</p>
                            <button onClick={() => navigate('/projects/new')} className="text-primary hover:underline mt-2">Crear el primero</button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Projects;
